import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import ReminderID from './ReminderID'
import TReminderDM from './TReminderDM'
import TTextDM from './TTextDM'

export default class TDocumentReminderDM extends Data {
	public static className = 'TDocumentReminderDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	DelayDays?: number
	LateCharges?: number
	LateChargesC?: number
	RemainingAmount?: number
	RemainingAmountC?: number
	AmountPaid?: number
	AmountPaidC?: number
	AmountGross?: number
	AmountGrossC?: number
	DueDate?: Date
	AccountingTransactionDate?: Date
	DocumentRID?: number
	DocumentTypeId?: number
	SequenceNumber?: number
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	ReminderDocumentIdentificationCalc?: string
	ReminderDateCalc?: Date
	ReminderCurrencyCalc?: string
	@Type(() => ReminderID)
	ReminderSequenceNumber?: ReminderID
	@Type(() => TReminderDM)
	HeaderRID?: TReminderDM
	@Type(() => TTextDM)
	ConfirmedOrCanceledIdCalc?: TTextDM
}